import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Clapperboard, LogOut } from 'lucide-react'

import Menu from '@mui/material/Menu'
import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ListItemIcon, ListItemText } from '@mui/material'

import { useAuth } from '../../context/SecurityContextProvider'

export default function NavDropDownBtn({ username }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const navigate = useNavigate()
    const { logout } = useAuth()

    const handleClick = (event) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)
    const handleStudio = () => { handleClose(); navigate("/studio") }
    const handleLogout = () => { logout(); handleClose(); navigate("/") }

    // --- defined styles object
    const styles = {
        button: (theme) => ({
            textTransform: 'none',
            textDecoration: 'none',
            alignSelf: 'center',
            padding: '.4rem 1rem',
            borderRadius: '20px',
            background: '#fff',
            color: '#000',
            fontFamily: 'inherit',
            fontSize: '1rem',
            fontWeight: 600,
            boxShadow: "0px 3px 4px #000",
            ":hover": {
                backgroundColor: theme.palette.primary.bg,
            },
        }),
        menuItemIcon: {
            ml: 'auto',
            color: '#000',
        },
        logoutMenuItem: {
            gap: 1,
        }
    }

    return (
        <>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={<ExpandMoreIcon />}
                sx={(theme) => styles.button(theme)}
            >
                {username}
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={handleStudio}>
                    <ListItemText>Studio</ListItemText>
                    <ListItemIcon sx={styles.menuItemIcon}>
                        <Clapperboard />
                    </ListItemIcon>
                </MenuItem>

                <MenuItem onClick={handleLogout} sx={styles.logoutMenuItem}>
                    <ListItemText>Log out</ListItemText>
                    <ListItemIcon sx={styles.menuItemIcon}>
                        <LogOut />
                    </ListItemIcon>
                </MenuItem>
            </Menu>
        </>
    )
}
